var metaNavScroll;

(function($) {

    metaNavScroll = function(selector) {
        // check if object exists
        if(selector.length) {
            var lastScrollTop = 0;
            var scrollDistance = 0;
            var scrollUp = 0;
            // on scroll
            $(window).scroll(function(event){
                var st = $(this).scrollTop();
                // when scrolling down
                if (st > lastScrollTop && $(window).width() <= 767 ){
                    scrollUp = 0;
                    // determine scroll distance
                    scrollDistance = (st - lastScrollTop) + scrollDistance;
                    // after scrolling down 150px, collapse metanav
                    // prevent metanav from collapsing when mobile menu is open
                    if (scrollDistance > 150 && !$('.mobile-nav').hasClass('open')) {
                        selector.addClass('collapsed');
                    }
                // when scrolling up
                } else {
                    scrollUp = st - lastScrollTop + scrollUp;
                    if (scrollUp < -10) {
                        selector.removeClass('collapsed');
                    }
                    // reset scroll distance
                    scrollDistance = 0;
                }
                // save scroll distance to top
                lastScrollTop = st;
            });
        }
    }

})(jQuery);